import { render, staticRenderFns } from "./AuthorizedStep.vue?vue&type=template&id=2ac4314e&scoped=true&"
import script from "./AuthorizedStep.vue?vue&type=script&lang=js&"
export * from "./AuthorizedStep.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizedStep.vue?vue&type=style&index=0&id=2ac4314e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4314e",
  null
  
)

export default component.exports